import { render, staticRenderFns } from "./MeetingReportMailPopup.vue?vue&type=template&id=2bfb4cf4&"
import script from "./MeetingReportMailPopup.vue?vue&type=script&lang=js&"
export * from "./MeetingReportMailPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports